import { getFullDate, getFullDateTime } from '../../../../../utils/dateTimeUtil';

export const renderFormValue = (field, entry) => {
    const dataType = field.data_type;
    let resultString = '';
    const value = entry?.content?.[field.name];
    if (!value) {
        return null;
    }
    if (dataType === 'select') {
        if (typeof value === 'string') {
            resultString = value;
        } else {
            const choices = value?.choices?.length;
            const others = value?.others?.length;
            if (choices) {
                typeof value?.choices[0] === 'string'
                    ? value?.choices?.forEach?.((item, index) => {
                          resultString += item;
                          resultString += index < choices - 1 ? ', ' : '';
                      })
                    : value?.choices?.forEach?.((item, index) => {
                          resultString += item[1];
                          resultString += index < choices - 1 ? ', ' : '';
                      });
            } else if (others) {
                value?.others?.forEach?.((item) => {
                    resultString += item;
                });
            }
        }
    } else if (dataType === 'date') {
        resultString = getFullDate(value);
        return resultString;
    } else if (dataType === 'datetime') {
        resultString = getFullDateTime(value);
        return resultString;
    } else if (dataType === 'integer' || dataType === 'float') {
        return value;
    } else {
        resultString = value;
    }
    return resultString;
};
